import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import AuthService from "../../../services/AuthService";

const Auth = new AuthService();

export default ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        Auth.isLoggedIn() ?
            <Component {...props} /> :
            <Redirect to={{
                pathname: "/",
                state: { from: props.location }
            }} />
    )} />
);


// WEBPACK FOOTER //
// ./src/components/shared/utils/PrivateRoute.js